export const SUPPORTS_ARRAY_PROTOTYPE_SHIFT = "shift" in Array.prototype;
